import { render, staticRenderFns } from "./PageStreams.vue?vue&type=template&id=21b9cd58&"
import script from "./PageStreams.vue?vue&type=script&lang=js&"
export * from "./PageStreams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b9cd58')) {
      api.createRecord('21b9cd58', component.options)
    } else {
      api.reload('21b9cd58', component.options)
    }
    module.hot.accept("./PageStreams.vue?vue&type=template&id=21b9cd58&", function () {
      api.rerender('21b9cd58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/streams/PageStreams.vue"
export default component.exports